import useTextRoutingEnabled from "hooks/use-text-routing-enabled.hook";
import {
  TextRoutingCounts,
  useGetTextRoutingCountsQuery
} from "services/text-routing";

import useInboxScope from "./use-inbox-scope.hook";

type Options = {
  skip?: boolean;
  pollingInterval?: number;
};

/**
 * Waiting-for-reply counts in the Inbox list's scope. Never requested unless
 * patient text routing is on. `counts` is gated on `routingOn` as well as the
 * `skip`: RTK keeps the last response when a query flips to skipped, so a
 * practice switching routing off would otherwise keep showing stale counts.
 * An empty clinic scope (`[]`, not resolved yet) is skipped too: the request
 * builder drops an empty array, which would turn it into a practice-wide count.
 */
export default function useTextRoutingCounts({
  skip = false,
  pollingInterval
}: Options = {}): { counts: TextRoutingCounts | undefined } {
  const { routingOn } = useTextRoutingEnabled();
  const { clinicFilter, region } = useInboxScope();
  const shouldSkip = skip || !routingOn || clinicFilter?.length === 0;

  const { data } = useGetTextRoutingCountsQuery(
    { preferred_clinic: clinicFilter, region },
    { skip: shouldSkip, pollingInterval }
  );

  return { counts: shouldSkip ? undefined : data };
}
